// extracted by mini-css-extract-plugin
module.exports = {"card":"PostcardBack_card__34jhl","message":"PostcardBack_message__4_RHC","divider":"PostcardBack_divider__3p1uo"};